import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faUser, faCode, faEnvelope } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <header className="backdrop-blur-md bg-gray-900 bg-opacity-50 text-white fixed w-full z-50 shadow-lg">
            <div className="container mx-auto px-4 flex justify-between items-center py-4">
                {/* Logo */}
                <div className="cursor-pointer text-2xl font-bold tracking-wider hover:text-teal-400 transition duration-300">
                    Bheesham
                </div>

                {/* Desktop Menu */}
                <nav className="hidden md:flex space-x-8">
                    <a
                        href="#home"
                        className="hover:text-teal-400 transition duration-300 flex items-center"
                    >
                        <FontAwesomeIcon icon={faHome} className="mr-2" /> Home
                    </a>
                    <a
                        href="#about"
                        className="hover:text-teal-400 transition duration-300 flex items-center"
                    >
                        <FontAwesomeIcon icon={faUser} className="mr-2" /> About
                    </a>
                    <a
                        href="#projects"
                        className="hover:text-teal-400 transition duration-300 flex items-center"
                    >
                        <FontAwesomeIcon icon={faCode} className="mr-2" /> Projects
                    </a>
                    <a
                        href="#contact"
                        className="hover:text-teal-400 transition duration-300 flex items-center"
                    >
                        <FontAwesomeIcon icon={faEnvelope} className="mr-2" /> Contact
                    </a>
                </nav>

                {/* Mobile Menu Toggle */}
                <button
                    className="md:hidden text-teal-400 focus:outline-none"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    <span className="text-2xl">&#9776;</span>
                </button>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <nav className="md:hidden bg-gray-800 bg-opacity-90 backdrop-blur-md py-4">
                    <a
                        href="#home"
                        className=" px-4 py-2 hover:bg-teal-400 hover:text-gray-900 transition duration-300 flex items-center"
                        onClick={() => setIsMenuOpen(false)}
                    >
                        <FontAwesomeIcon icon={faHome} className="mr-2" /> Home
                    </a>
                    <a
                        href="#about"
                        className=" px-4 py-2 hover:bg-teal-400 hover:text-gray-900 transition duration-300 flex items-center"
                        onClick={() => setIsMenuOpen(false)}
                    >
                        <FontAwesomeIcon icon={faUser} className="mr-2" /> About
                    </a>
                    <a
                        href="#projects"
                        className=" px-4 py-2 hover:bg-teal-400 hover:text-gray-900 transition duration-300 flex items-center"
                        onClick={() => setIsMenuOpen(false)}
                    >
                        <FontAwesomeIcon icon={faCode} className="mr-2" /> Projects
                    </a>
                    <a
                        href="#contact"
                        className=" px-4 py-2 hover:bg-teal-400 hover:text-gray-900 transition duration-300 flex items-center"
                        onClick={() => setIsMenuOpen(false)}
                    >
                        <FontAwesomeIcon icon={faEnvelope} className="mr-2" /> Contact
                    </a>
                </nav>
            )}
        </header>
    );
};

export default Header;
